import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  startLoadingChart,
  setChartData,
  setChartError,
  setChartFilter,
} from "../../store/admin/chartSlice";
import { gosafeApi } from "../../api";
import { translations } from "../../helpers";

export const useChartStore = () => {
  const dispatch = useDispatch();

  const getDataPatientSurgeryByTrack = useCallback(
    async (filters) => {
      try {
        dispatch(startLoadingChart("patientSurgeryByTrack"));

        const filteredParams = Object.fromEntries(
          Object.entries({
            ...filters,
          }).filter(([_, value]) => value !== "")
        );

        const { data } = await gosafeApi.get(`chart/patientSurgeryByTrack`, {
          params: filteredParams,
        });

        dispatch(setChartData({ chartId: "patientSurgeryByTrack", data }));
        return;
      } catch (error) {
        const errorMessage =
          translations[error?.response?.data?.message] ||
          error?.response?.data?.message ||
          error?.message;

        dispatch(
          setChartError({
            chartId: "patientSurgeryByTrack",
            error: errorMessage,
          })
        );
        return;
      }
    },
    [dispatch]
  );

  const getDataQuestionSatisfaction = useCallback(
    async (filters) => {
      try {
        dispatch(startLoadingChart("questionSatisfaction"));

        const filteredParams = Object.fromEntries(
          Object.entries({
            ...filters,
          }).filter(([_, value]) => value !== "")
        );

        const { data } = await gosafeApi.get(`chart/questionSatisfaction`, {
          params: filteredParams,
        });

        // console.log("data", data);

        dispatch(setChartData({ chartId: "questionSatisfaction", data }));
        return;
      } catch (error) {
        const errorMessage =
          translations[error?.response?.data?.message] ||
          error?.response?.data?.message ||
          error?.message;

        dispatch(
          setChartError({
            chartId: "questionSatisfaction",
            error: errorMessage,
          })
        );
        return;
      }
    },
    [dispatch]
  );

  const setChartFilterAction = (chartId, filterKey, filterValue) => {
    dispatch(setChartFilter({ chartId, filterKey, filterValue }));
  };

  const getDataPatientSurgeryByAssessmentMade = useCallback(
    async (filters) => {
      try {
        dispatch(startLoadingChart("patientSurgeryByAssessmentMade"));

        const filteredParams = Object.fromEntries(
          Object.entries({
            ...filters,
          }).filter(([_, value]) => value !== "")
        );

        const { data } = await gosafeApi.get(`chart/patientSurgeryByAssessmentMade`, {
          params: filteredParams,
        });

        dispatch(setChartData({ chartId: "patientSurgeryByAssessmentMade", data }));
        return;
      } catch (error) {
        const errorMessage =
          translations[error?.response?.data?.message] ||
          error?.response?.data?.message ||
          error?.message;

        dispatch(
          setChartError({
            chartId: "patientSurgeryByAssessmentMade",
            error: errorMessage,
          })
        );
        return;
      }
    },
    [dispatch]
  );

  return {
    getDataPatientSurgeryByTrack,
    getDataPatientSurgeryByAssessmentMade,
    getDataQuestionSatisfaction,
    setChartFilter: setChartFilterAction,
  };
};
